import { render, staticRenderFns } from "./BasicCaseData.vue?vue&type=template&id=61317ddf&scoped=true&"
import script from "./BasicCaseData.vue?vue&type=script&lang=js&"
export * from "./BasicCaseData.vue?vue&type=script&lang=js&"
import style0 from "./BasicCaseData.vue?vue&type=style&index=0&id=61317ddf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61317ddf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCardText,VCol,VContainer,VIcon,VRow,VTooltip})
